export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_5.213ac14b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};